// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__OTt0Y"};